import React, { useState, useContext } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { UserContext } from '../UserContext';  // Importer le UserContext

function Login() {
  const API_URL = process.env.REACT_APP_API_URL;
  const [formData, setFormData] = useState({
    username: '',
    password: '',
  });
  const [errorMessage, setErrorMessage] = useState('');
  const navigate = useNavigate();
  const { setUser } = useContext(UserContext);  // Accéder à la fonction de mise à jour de l'utilisateur

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(`${API_URL}/cours/api/token/`, formData);
      if (response.status === 200) {
        localStorage.setItem('access_token', response.data.access);
        localStorage.setItem('refresh_token', response.data.refresh);

        // Récupérer les informations utilisateur après la connexion
        const userResponse = await axios.get(`${API_URL}/cours/api/user/`, {
          headers: {
            'Authorization': `Bearer ${response.data.access}`
          }
        });
        setUser(userResponse.data);  // Mettre à jour l'utilisateur dans le contexte

        // Rediriger l'utilisateur
        navigate('/');
        window.location.reload();
      }
    } catch (error) {
      setErrorMessage('Nom d\'utilisateur ou mot de passe incorrect.');
    }
  };

  return (
    <div className="login min-h-screen bg-gray-100 flex items-center justify-center">
      <div className="bg-white p-8 rounded-lg shadow-lg max-w-md w-full">
      <h2 className="text-2xl font-bold mb-6 text-center text-blue-600">Connexion</h2>
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label className="block text-gray-700">Nom d'utilisateur :</label>
          <input 
            type="text" 
            name="username" 
            value={formData.username} 
            onChange={handleChange} 
            className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" 
            required 
          />
        </div>
        <div>
          <label className="block text-gray-700">Mot de passe :</label>
          <input 
            type="password" 
            name="password" 
            value={formData.password} 
            onChange={handleChange} 
            className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" 
            required 
          />
        </div>
        {errorMessage && <p className="text-red-500">{errorMessage}</p>}
        <button type="submit" className="w-full bg-blue-500 text-white py-2 rounded-md hover:bg-blue-700 transition">
          Se connecter
          </button>
      </form>
      </div>
    </div>
  );
}

export default Login;
